import { FilePicker as Root } from './FilePicker'
import { Description, Icon, Title } from './primitives'
export const FilePicker = { Root, Title, Description, Icon }
export { FilePickerPrimitive } from './primitives'
export { FileRejectionCode } from './types'
export type { FileRejection } from './types'
